import React from "react";

import { connect } from "react-redux";
import { Row, Nav, NavItem } from "react-bootstrap";
import { hasSellerAccount } from "shared/storeInfo";
import ProductLineTabContent from "./ProductLineTabContent";
import {
  selectTabAction,
  fetchProductAnalyticsAction,
} from "./StartupsDashboardActions";

const mapStateToProps = store => {
  const activeTabKey = store.data.StartupsDashboard.activeTabKey || 0;
  return {
    activeTabKey,
    productLines: Object.values(store.data.productLines),
    productLinesAnalytics: store.data.productLinesAnalytics,
  };
};

export class ProductLineTabs extends React.Component {
  componentDidMount() {
    if (this.getCurrentProductLine()) {
      const { ids, name } = this.getCurrentProductLine();
      this.props.dispatch(fetchProductAnalyticsAction(ids, name));
    }
  }

  getCurrentProductLine() {
    return this.props.productLines[this.props.activeTabKey];
  }

  getCurrentProductLineAnalytics() {
    if (this.props.productLinesAnalytics && this.getCurrentProductLine()) {
      return this.props.productLinesAnalytics[
        this.getCurrentProductLine().name
      ];
    }
    return undefined;
  }

  handleSelect(navItemEventKey, event) {
    if (navItemEventKey === "new_product") {
      window.location.href = event.target.href;
      return;
    }

    if (typeof navItemEventKey === "number") {
      this.props.dispatch(dispatch => {
        dispatch(selectTabAction(navItemEventKey));
        const selectedProductLine = this.props.productLines[navItemEventKey];
        dispatch(
          fetchProductAnalyticsAction(
            selectedProductLine.ids,
            selectedProductLine.name,
          ),
        );
      });
      /* eslint-disable no-unused-expressions */
      this.props.onSelectTab && this.props.onSelectTab(navItemEventKey);
      /* eslint-enable no-unused-expressions */
    }
  }

  render() {
    const productLinesTabItems = this.props.productLines.map(
      (productLine, i) => {
        return (
          <NavItem key={i} eventKey={i} title="{productLine.name}">
            <div>{productLine.name}</div>
          </NavItem>
        );
      },
    );

    return (
      <Row>
        <Nav
          id="startup-dashboard-page-product-line-tabs"
          bsStyle="tabs"
          justified
          activeKey={this.props.activeTabKey}
          onSelect={this.handleSelect.bind(this)}
        >
          {productLinesTabItems}
          {hasSellerAccount() && (
            <NavItem eventKey="new_product" href="/startups/products/new">
              Neues Produkt +
            </NavItem>
          )}
        </Nav>

        <ProductLineTabContent
          id="startup-dashboard-page-product-line-content"
          productLineAnalytics={this.getCurrentProductLineAnalytics()}
        />
      </Row>
    );
  }
}

// Normally, we would use the decorator language feature and define `@connect`
// in the beginning of the class definition. But we found out that splitting
// the `export default` and the normal `export` helps us to test this
// component separately.
// If we do not do this, testing this component create lots of hassle because
// of the redux integration.
// Please ask Gerardo for more information on that.
export default connect(mapStateToProps)(ProductLineTabs);
